import {Pipe, PipeTransform} from '@angular/core';
import {AttributeItem} from 'src/app/users/_interfaces/users-admin';
import {QuestionConfig} from '../interfaces/process-config.interface';

@Pipe({name: 'questionAttributes'})
export class QuestionAttributesPipe implements PipeTransform {
    transform(
        questions: QuestionConfig[],
        attributes: AttributeItem[],
        inverse: boolean = false
    ): QuestionConfig[] {
        if (!questions || questions.length === 0) return [];
        if (inverse)
            return questions.filter(
                (x) => !x.attributes || x.attributes.length === 0
            );
        let returnQuestions = [];
        questions
            .filter((x) => x.attributes && x.attributes.length > 0)
            .forEach((x) => {
                if (!x.attributes || x.attributes.length === 0) {
                    returnQuestions.push(x);
                    return;
                }
                let andAttributes = x.attributes.filter((x) => x.anD_OR === 0);
                let orAttributes = x.attributes.filter((x) => x.anD_OR === 1);
                let include = true;
                if (
                    andAttributes.length > 0 &&
                    !andAttributes.every(
                        (ga) =>
                            attributes && attributes.some((a) => a.id === ga.attributeId)
                    )
                ) {
                    include = false;
                }
                if (
                    include &&
                    orAttributes.length > 0 &&
                    !orAttributes.some(
                        (ga) =>
                            attributes && attributes.some((a) => a.id === ga.attributeId)
                    )
                ) {
                    include = false;
                }
                if (include) {
                    returnQuestions.push(x);
                }
            });
        return returnQuestions;
    }
}
